import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

export function useAppleBingeExp() {
	const { country } = storeToRefs(useLanguageStore());
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_APPLE_BINGE_2');

	const appleBingeExpShortName = computed(() => {
		if (!variant.value) return null;
		return variant.value === 'control' ? 'atp' : 'bng';
	});

	function setAppleBingeExpParams(url: ClickoutUrl, shortName: string) {
		if (!variant.value) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: country.value,
			placement: 'ft',
			providerShortName: shortName,
		});

		url.set('uct_ctag', tag);

		return url;
	}

	return {
		variant,
		appleBingeExpShortName,
		setAppleBingeExpParams,
	};
}
